import * as React from 'react'
import styled from 'styled-components'

const Container = styled.label`
  width: ${props => props.width};
  height: ${props => props.height};
  display: flex;
  position: relative;
  padding: 30px 10px 20px 20px;
  background-color: ${props => props.theme.color.background};
  border-radius: 10px;
  margin-bottom: 20px;
  cursor: text;

  &:focus-within {
    background-color: ${props => props.theme.color.backgroundRush};

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 10px;
      border: 1px solid ${props => props.theme.color.background};
    }
  }

  &:hover:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    border: 1px solid ${props => props.theme.color.pale};
  }
`

const Textarea = styled.textarea`
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: ${props => props.theme.color.mainFont};
  background-color: inherit;
  outline: none;
  border: none;
  resize: none;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.color.background};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.color.disabled};
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
      background: ${p => p.theme.color.gray};
    }

  &::placeholder {
    opacity: 0;
    color: ${props => props.theme.color.disabled};
  }

  &:focus {
    &::placeholder {
      opacity: 1;
    }

    & ~ span {
      top: 12px;
      font-size: 12px;
      color: ${props => props.theme.color.gray};
    }
  }
`

const Text = styled.span`
  position: absolute;
  left: 20px;
  top: ${props => (props.value ? '12px' : '20px')};
  font-size: ${props => (props.value ? '12px' : '16px')};
  color: ${props =>
    props.value ? props.theme.color.gray : props.theme.color.mainFont};
  transition: 0.2s ease all;
`

export default ({ width, height, text, input, type, placeholder }) => {
  const inputProps = { ...input, type, placeholder }
  const { value } = input
  return (
    <Container width={width} height={height}>
      <Textarea {...inputProps} />
      <Text value={value}>{text}</Text>
    </Container>
  )
}
